import LinesEllipsis from "react-lines-ellipsis";
import responsiveHOC from "react-lines-ellipsis/lib/responsiveHOC";

const ResponsiveLinesEllipsis = responsiveHOC()(LinesEllipsis);
export default ResponsiveLinesEllipsis;
